module.exports = __webpack_public_path__ + "img/banner_ramen_2.9630f9a.png";